import { Hacker } from "@paulie/ui";
import { A } from "@solidjs/router";
import { Component } from "solid-js";
import { ORCHARD_URL } from "../config";
import { Background } from "../components/Background";

const NotFound: Component = () => {
  return (
    <>
      <Background />
      <div class="relative flex min-h-screen flex-col items-center justify-center px-4 py-8 font-mono">
        <div class="w-full max-w-2xl space-y-8 text-center">
          {/* Large 404 with Hacker Effect */}
          <div class="space-y-4">
            <h1 class="text-8xl font-bold tracking-wider text-cyan-400 sm:text-9xl">
              <Hacker>404</Hacker>
            </h1>
            <h2 class="text-2xl font-semibold tracking-wide text-fuchsia-400 sm:text-3xl">
              <Hacker>Page Not Found</Hacker>
            </h2>
          </div>

          {/* Description */}
          <div class="space-y-4">
            <p class="text-lg text-gray-300">
              Looks like you've ventured into uncharted territory.
            </p>
            <p class="text-sm text-gray-400">
              The page you're looking for doesn't exist in the current data
              stream.
            </p>
          </div>

          {/* Glitch Separator */}
          <div class="flex items-center justify-center space-x-2 py-4">
            <div class="h-px w-16 bg-gradient-to-r from-transparent to-cyan-500"></div>
            <div class="h-2 w-2 animate-pulse rounded-full bg-fuchsia-500"></div>
            <div class="h-px w-16 bg-gradient-to-l from-transparent to-cyan-500"></div>
          </div>

          {/* Navigation Links */}
          <div class="space-y-4">
            <p class="text-sm font-semibold tracking-wider text-gray-400 uppercase">
              Navigate To
            </p>
            <div class="grid gap-3 sm:grid-cols-2">
              <A
                href="/"
                class="group relative overflow-hidden rounded-lg border border-cyan-500/30 bg-black/50 px-6 py-4 text-cyan-400 backdrop-blur-sm transition-all duration-300 hover:border-cyan-400 hover:bg-cyan-500/10 focus:border-cyan-400 focus:bg-cyan-500/10 focus:ring-2 focus:ring-cyan-400/50 focus:outline-none"
              >
                <span class="relative z-10 flex items-center justify-center space-x-2">
                  <span>Home</span>
                  <span class="text-xs opacity-60">/</span>
                </span>
                <div class="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-cyan-500/10 to-transparent transition-transform duration-500 group-hover:translate-x-full"></div>
              </A>

              <a
                href={ORCHARD_URL}
                class="group relative overflow-hidden rounded-lg border border-fuchsia-500/30 bg-black/50 px-6 py-4 text-fuchsia-400 backdrop-blur-sm transition-all duration-300 hover:border-fuchsia-400 hover:bg-fuchsia-500/10 focus:border-fuchsia-400 focus:bg-fuchsia-500/10 focus:ring-2 focus:ring-fuchsia-400/50 focus:outline-none"
              >
                <span class="relative z-10 flex items-center justify-center space-x-2">
                  <span>ORCHARD</span>
                  <span class="text-xs opacity-60">orchard.paulie.app</span>
                </span>
                <div class="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-fuchsia-500/10 to-transparent transition-transform duration-500 group-hover:translate-x-full"></div>
              </a>

              <A
                href="/demos/scroll-driven"
                class="group relative overflow-hidden rounded-lg border border-cyan-500/30 bg-black/50 px-6 py-4 text-cyan-400 backdrop-blur-sm transition-all duration-300 hover:border-cyan-400 hover:bg-cyan-500/10 focus:border-cyan-400 focus:bg-cyan-500/10 focus:ring-2 focus:ring-cyan-400/50 focus:outline-none"
              >
                <span class="relative z-10 flex items-center justify-center space-x-2">
                  <span>Scroll Demos</span>
                  <span class="text-xs opacity-60">/demos/scroll-driven</span>
                </span>
                <div class="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-cyan-500/10 to-transparent transition-transform duration-500 group-hover:translate-x-full"></div>
              </A>

              <A
                href="/demos/view-transitions"
                class="group relative overflow-hidden rounded-lg border border-fuchsia-500/30 bg-black/50 px-6 py-4 text-fuchsia-400 backdrop-blur-sm transition-all duration-300 hover:border-fuchsia-400 hover:bg-fuchsia-500/10 focus:border-fuchsia-400 focus:bg-fuchsia-500/10 focus:ring-2 focus:ring-fuchsia-400/50 focus:outline-none"
              >
                <span class="relative z-10 flex items-center justify-center space-x-2">
                  <span>View Transitions</span>
                  <span class="text-xs opacity-60">
                    /demos/view-transitions
                  </span>
                </span>
                <div class="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-fuchsia-500/10 to-transparent transition-transform duration-500 group-hover:translate-x-full"></div>
              </A>
            </div>
          </div>

          {/* Footer Message */}
          <div class="pt-8">
            <p class="text-xs text-gray-400">
              <span class="text-cyan-400/60">[</span> Error Code: 404{" "}
              <span class="text-cyan-400/60">]</span>
              <span class="mx-2 text-gray-600">|</span>
              <span class="text-fuchsia-400/60">[</span> Resource Not Found{" "}
              <span class="text-fuchsia-400/60">]</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
